import React from 'react'

export default function LoadingOverlay() {
  return (
    <div className="fixed z-max top-0 left-0 w-100 h-100 o-30 bg-black flex items-center justify-center">
      <div className="loading-animation w8 h8 br-100 bl b--white" />
    </div>
  )
}
